'use strict';

export class Userprofile {
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		this.data = {};
		this.send_data = {};
		this.api = '';
		this.action = '';
		this.$root = jQuery(`.js-${this.id}`);
		this.$actions = this.$root.find('.js-profile_action');
		this.$dropdown_toggle = this.$root.find('.js-userprofile_actions_toggle');
		this.$dropdown = this.$root.find('.js-userprofile_actions_dropdown');
		this.action_context = null;
	}
	
	init() {
		this.add_events();
	}
	add_events() {
		this.$actions.off('click.userprofile').on('click.userprofile', (event, context) => {
			const $element = jQuery(event.currentTarget);
			const action = $element.data('action');

			if (action === 'block' || action === 'unblock') {
				this.handle_block_unblock($element, action);
			} else {
				this.menu_action_item_click_handler(event, context);
			}

			if ($element.hasClass('js-profile_dropdown_action') && context !== 'via_contact_form') {
				this.$dropdown.addClass('hidden');
				this.$dropdown_toggle.removeClass('active');
			}
		});

		this.$dropdown_toggle.off('click.userprofile_toggle').on('click.userprofile_toggle', this.toggle_dropdown.bind(this));
		this.$root.find('.js-default_login').off('click.userprofile_default_login').on('click.userprofile_default_login', (event) => {
			const $element = jQuery(event.currentTarget);
			if ($element.hasClass('js-profile_dropdown_action')) {
				this.$dropdown.addClass('hidden');
				this.$dropdown_toggle.removeClass('active');
			}
		});
		
		if (this.id === 'userprofile_vap') {
			this.combined_view_observer();
		}
		this.setup_avatar_upload();
		
		jQuery(document).on('click.userprofile_dropdown_close', (event) => {
			if (!jQuery(event.target).closest('.js-userprofile_actions_toggle').length &&
				!jQuery(event.target).closest('.js-userprofile_actions_dropdown').length) {
				this.$dropdown.addClass('hidden');
				this.$dropdown_toggle.removeClass('active');
			}
		});
	}

	toggle_dropdown(event) {
		event.preventDefault();
		event.stopPropagation();
		this.$dropdown.toggleClass('hidden');
		this.$dropdown_toggle.toggleClass('active', !this.$dropdown.hasClass('hidden'));
	}

	handle_block_unblock($element, action) {
		if (!yalwa.basics.readonly_check()) {
			return false;
		}
		
		this.action = action;
		this.api = '/api/ajax/ignore_user';
		this.send_data = {
			ignore: this.action === 'block' ? 1 : 0,
			emailID: $element.data('emailid')
		};

		this.ajax_call().done((response) => {
			if (response.success) {
				location.reload(); 
			} else {
				yalwa.basics.toast({message: response.error || yalwa.v.lang.an_error_occurred, type: 'error'});
			}
		});
	}

	combined_view_observer() {
		const header = document.querySelector(`.js-headroom`);
		const target = document.querySelector(`.js-userprofile_vap`);
		const fade_element = document.querySelector(`.js-userprofile_vapcombined`);
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				// intersectionRatio: 0 (not visible) → 1 (fully visible)
				const is_desktop = window.matchMedia('(min-width: 1080px)').matches;
				
				if (!is_desktop) {
					// On mobile/tablet: always visible
					fade_element.style.opacity = '1';
					fade_element.style.pointerEvents = 'auto';
					fade_element.style.top = '';
					return;
				}
				
				const ratio = entry.intersectionRatio;
				if (ratio >= 0.98) {
					fade_element.style.pointerEvents = 'none';
				} else {
					fade_element.style.pointerEvents = 'auto';
				}
				// Reverse: fully visible → opacity 0, barely visible → opacity 1
				fade_element.style.opacity = 1 - ratio;
				fade_element.style.top = header.clientHeight + 8 + 'px';
			});
		}, {
			root: null,        // viewport
			rootMargin: "-70px 0px 0px 0px", // top is 70px earlier
			threshold: Array.from({ length: 101 }, (_, i) => i / 100) // smooth updates
		});
		
		observer.observe(target);
	}
	menu_action_item_click_handler(event, context) {
		this.action_context = context;
		if (!yalwa.basics.readonly_check()) {
			return false;
		}
		const $element = jQuery(event.currentTarget);
		this.action = $element.data('action');
		switch(this.action) {
			case 'unfollow':
			case 'follow':
				this.api = '/api/ajax/follow_user';
				this.send_data = {
					action: this.action,
					userID: $element.data('userid'),
                    msgID: (yalwa.basics.get_routing() === 'vap') ? yalwa.v.posting_id : null
				};
				break;
		}
		this.ajax_call().done(this.ajax_response_handler.bind(this, $element));
	}
	ajax_call() {
		return jQuery.ajax({
			url: this.api,
			type: 'post',
			dataType: 'json',
			data: this.send_data
		});
	}
	
	ajax_response_handler($element, response) {
		if (response.success) {
			// update component state
			if (this.action === 'follow') {
				this.component.followed = true;
				this.update_followers_counter(1);
			} else if (this.action === 'unfollow') {
				this.component.followed = false;
				this.update_followers_counter(-1);
			}

			// modify all follower button elements (both outside and inside dropdown)
			const $elements = jQuery('.js-profile_action');
            if (this.action === 'follow' && response.nudge && response.nudge_plp && this.action_context !== 'via_contact_form') {
                jQuery('.js-plp_container')
					.append(response.nudge_plp)
					.addClass('plp_container--center');
                yalwa.mobile.check_for_detach();
                let $nudge_plp = jQuery('.js-plp_nudge_follow');
                $nudge_plp.trigger('plp_show');
                yalwa.mobile.init_nudge();
            } else {
				if (!response.nudge && this.action_context !== 'via_contact_form') {
					yalwa.basics.toast({message: $element.data('message'), type: 'success'});
				}
            }
			$elements.each((index, element) => {
				yalwa.basics.toggle(jQuery(element));
			});
		} else {
			yalwa.basics.toast({message: yalwa.v.lang.an_error_occurred, type: 'error'});
		}
	}
	update_followers_counter (count) {
		const $followers_counter = jQuery('.js-followers_counter').find('.js-userprofile_info_label');
		$followers_counter.html(parseInt($followers_counter.html()) + parseInt(count));
	}
	setup_avatar_upload() {
		const $edit_icon = this.$root.find('.js-userprofile__edit_icon, .userprofile__edit_icon');
		if (!$edit_icon.length) return;

		// In the android app the upload menu component creates and binds its own input
		if (!(yalwa.v.is_phonegap && !yalwa.v.is_ios)) {
			const $file_input = this.create_avatar_input();

			$edit_icon.off('click.userprofile').on('click.userprofile', () => {
				$file_input[0].click();
			});
		}

		jQuery(document).off('androiduploadmenu_done.userprofile').on('androiduploadmenu_done.userprofile', (event, data) => {
			this.handle_avatar_upload_response(data);
		});
	}

	create_avatar_input() {
		const file_input = document.createElement('input');
		file_input.type = 'file';
		file_input.accept = 'image/*';
		file_input.style.display = 'none';
		document.body.appendChild(file_input);

		file_input.addEventListener('change', (event) => {
			const file = event.target.files[0];
			event.target.value = '';
			this.handle_avatar_upload(file);
		});

		return jQuery(file_input);
	}
	handle_avatar_upload(file) {
		if (!file) return;

		const form_data = new FormData();
		form_data.append('avatar', file);

		fetch('/api/ajax/avatar_upload', {
			method: 'POST',
			body: form_data,
			credentials: 'include'
		})
		.then(response => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		})
		.then(data => this.handle_avatar_upload_response(data))
		.catch(error => {
		});
	}
	handle_avatar_upload_response(data) {
		if (!data) return;

		let errors = [];
		if (data.errors) {
			try {
				errors = JSON.parse(data.errors);
			} catch (e) {
				errors = [data.errors];
			}
		}

		if (errors && errors.length > 0) {
			return;
		}

		if (!data.image_url) {
			return;
		}

		if (data.vip_completion) {
			document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: data.vip_completion}));
		}

		// Handle regular img tag
		const $avatar_img = this.$root.find('.userprofile__avatar');
		if ($avatar_img.length) {
			$avatar_img.attr('src', data.image_url);
		}

		// Handle Web Component avatar (yalwa-avatar) if present
		const $ywc_avatar = this.$root.find('yalwa-avatar');
		if ($ywc_avatar.length) {
			$ywc_avatar.attr('appearance', 'image'); // ensure appearance is set
			$ywc_avatar.attr('src', data.image_url);
		}

		this.show_upload_success(data.label_success_title, data.label_success_body);
	}
	show_upload_success(title, message) {
		yalwa.basics.toast({
			title: title,
			message: message,
			type: 'success',
			timeOut: 2000
		});
	}
}
Object.keys(yalwa.v.components).map(component_key => {
	if (component_key === 'userprofile' || component_key.startsWith('userprofile_')) {
		new Userprofile(component_key).init();
	}
})
